import { render } from "./what-type.vue?vue&type=template&id=4c188fb3&scoped=true&lang=pug"
import script from "./what-type.vue?vue&type=script&lang=js"
export * from "./what-type.vue?vue&type=script&lang=js"

import "./what-type.vue?vue&type=style&index=0&id=4c188fb3&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c188fb3"]])

export default __exports__